var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentChatIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28C23.1797 28 29 22.1797 29 15C29 7.8203 23.1797 2 16 2C8.8203 2 3 7.8203 3 15C3 22.1797 8.8203 28 16 28Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.2277V17.1793C26 18.1591 25.2057 18.9534 24.2259 18.9534H22.9385C21.6628 22.4954 18.4054 24.6348 16 24.6348C13.5946 24.6348 10.3372 22.4954 9.0615 18.9534H7.77412C6.79428 18.9534 6 18.1591 6 17.1793V15.2277C6 14.5535 6.37618 13.9672 6.93007 13.667C6.94866 10.8962 7.75621 8.73229 9.33376 7.23631C10.8985 5.75245 13.1414 5 16 5C18.8586 5 21.1015 5.75245 22.6662 7.23627C24.2438 8.73225 25.0513 10.8962 25.0699 13.667C25.6238 13.9672 26 14.5535 26 15.2277ZM22.2451 15.8066C22.2451 15.3501 22.2217 14.9212 22.1872 14.5056C21.3998 13.7852 19.9705 13.2386 18.1665 13.0355C18.4034 13.3019 18.608 13.6522 18.7321 14.1134C17.6271 13.2429 15.4582 13.4501 13.8176 11.5021C13.7236 11.3933 13.6422 11.2894 13.5719 11.1944L13.5693 11.1912C13.2775 10.7965 13.1782 10.5618 13.1726 10.8217C13.1245 13.0607 11.5375 14.8062 9.77529 15.0524C9.76415 15.2987 9.75503 15.5473 9.75503 15.8067C9.75503 16.753 9.90958 17.6156 10.1723 18.3928C11.1622 19.5869 12.7969 19.924 14.2438 20.0134C14.5124 19.5861 15.115 19.2878 15.8168 19.2878C16.7684 19.2878 17.5397 19.8353 17.5397 20.5108C17.5397 21.1862 16.7683 21.7337 15.8168 21.7337C15.0849 21.7337 14.4612 21.4092 14.2115 20.9523C13.2003 20.8935 12.0887 20.7211 11.0979 20.2532C12.4912 22.3069 14.6511 23.3929 16 23.3929C18.1196 23.3929 22.2451 20.7153 22.2451 15.8066ZM24.0018 13.4536C23.8889 8.61863 21.1291 6.06451 16 6.06451C10.8709 6.06451 8.11114 8.61863 7.9982 13.4536H8.68078C8.93036 11.824 9.45784 10.4838 10.2587 9.45324C11.535 7.81114 13.4666 6.9785 16 6.9785C18.5334 6.9785 20.465 7.81114 21.7413 9.45324C22.5422 10.4837 23.0697 11.824 23.3192 13.4536H24.0018Z",
    fill: "#E40000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentChatIc);
export default __webpack_public_path__ + "static/media/agent_chat_ic.ecd2f265fb56c23d87905ea3a5a33ef9.svg";
export { ForwardRef as ReactComponent };